import type { UseMutationOptions } from "react-query";
import { useMutation } from "react-query";

import { reactQueryPatch } from "@/react/helpers/backendRequestHelpers";
import { internalApi } from "@/react/helpers/urlHelpers";

interface UpdateSpaceGroupMemberModeratorParams {
  isModerator: boolean;
  memberId: string | number;
  spaceGroupId: number;
}

export const useUpdateSpaceGroupMemberModerator = (
  options?: UseMutationOptions<
    unknown,
    Error,
    UpdateSpaceGroupMemberModeratorParams
  >,
) => {
  const mutation = async ({
    spaceGroupId,
    memberId,
    isModerator,
  }: UpdateSpaceGroupMemberModeratorParams) =>
    reactQueryPatch(
      internalApi.spaceGroups.updateMemberModerator({
        memberId,
        spaceGroupId,
      }),
      { moderator: isModerator },
    );

  return useMutation({ ...options, mutationFn: mutation });
};
